import i18next from 'i18next';
export const getDictionaryText = fieldName => {
  return i18next.t && i18next.t(fieldName) || '';
}